import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useRequestPreviewFlowStore} from 'presentation/pages/private/refund/pages/RequestPreview/store/useRequestPreviewFlowStore';
import {SelectTypeOptionLabels} from 'presentation/pages/private/refund/pages/RequestPreview/components/SelectTypeV2/types';

const emptySearchLabels =
	translations['pt-br'].privateFlow.refund.previewServiceType.proceduresForm
		.emptySearch;

export function EmptySearch() {
	const theme = useTheme();
	const selectedServiceTypeOption = useRequestPreviewFlowStore(
		state => state.selectedServiceTypeOption,
	);
	const isTherapies = selectedServiceTypeOption === SelectTypeOptionLabels.TERAPIAS;

	return (
		<Stack
			width="100%"
			maxWidth={502}
			margin="0 auto"
			padding="24px 16px"
			direction="column"
			alignItems="center"
			justifyContent="center"
			gap={2}>
			<Icon
				name="search-default"
				size={40}
				color={theme.palette.action.disabled}
			/>
			<Stack gap={1} alignItems="center">
				<Typography
					variant="h6"
					fontWeight={600}
					sx={{fontSize: 20}}
					color="text.primary"
					textAlign="center">
					{emptySearchLabels.title}
				</Typography>
				<Typography variant="body1" color="text.secondary" textAlign="center">
					{isTherapies
						? emptySearchLabels.subtitleTherapies
						: emptySearchLabels.subtitle}
				</Typography>
			</Stack>
		</Stack>
	);
}
